import {BaseDTO} from "./_baseDTO.interface";
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface VatStatusDTO extends BaseIntDTO {
  vatStatusName: string;
}
